<app-simple-coat-mix [job]="job()" coatId="clear"></app-simple-coat-mix>